import { useRef, useState } from "react";
import { ArrowsLeftRight } from "@phosphor-icons/react";

export default function BeforeAfterSlider({ beforeImage, afterImage, alt, testId, className = "" }) {
  const [percent, setPercent] = useState(50);
  const containerRef = useRef(null);
  const draggingRef = useRef(false);

  const updateFromClientX = (clientX) => {
    if (!containerRef.current || clientX == null) return;
    const rect = containerRef.current.getBoundingClientRect();
    const pct = ((clientX - rect.left) / rect.width) * 100;
    setPercent(Math.min(100, Math.max(0, pct)));
  };

  const handlePointerDown = (e) => {
    draggingRef.current = true;
    updateFromClientX(e.clientX ?? e.touches?.[0]?.clientX);
  };
  const handlePointerMove = (e) => {
    if (!draggingRef.current) return;
    updateFromClientX(e.clientX ?? e.touches?.[0]?.clientX);
  };
  const handlePointerUp = () => {
    draggingRef.current = false;
  };

  return (
    <div
      ref={containerRef}
      className={`relative select-none touch-none overflow-hidden ${className}`}
      onMouseDown={handlePointerDown}
      onMouseMove={handlePointerMove}
      onMouseUp={handlePointerUp}
      onMouseLeave={handlePointerUp}
      onTouchStart={handlePointerDown}
      onTouchMove={handlePointerMove}
      onTouchEnd={handlePointerUp}
    >
      <img src={afterImage} alt={`${alt} after`} className="absolute inset-0 w-full h-full object-cover" draggable={false} />
      <img
        src={beforeImage}
        alt={`${alt} before`}
        className="absolute inset-0 w-full h-full object-cover"
        style={{ clipPath: `inset(0 ${100 - percent}% 0 0)` }}
        draggable={false}
      />
      <input
        type="range"
        min={0}
        max={100}
        value={percent}
        onChange={(e) => setPercent(Number(e.target.value))}
        data-testid={testId}
        aria-label={`Before and after slider for ${alt}`}
        className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize"
      />
      <div className="absolute top-0 bottom-0 w-[2px] bg-white/90 pointer-events-none" style={{ left: `${percent}%` }} />
      <div
        className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-9 h-9 rounded-full bg-[#D4AF37] flex items-center justify-center shadow-lg pointer-events-none"
        style={{ left: `${percent}%` }}
      >
        <ArrowsLeftRight size={16} weight="bold" className="text-black" />
      </div>
      <span className="absolute top-3 left-3 text-[10px] uppercase tracking-wide bg-black/60 text-white px-2 py-1 rounded-full pointer-events-none">
        Before
      </span>
      <span className="absolute top-3 right-3 text-[10px] uppercase tracking-wide bg-[#D4AF37] text-black px-2 py-1 rounded-full pointer-events-none">
        After
      </span>
    </div>
  );
}
